import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PendingRequestsService {
  #pendingRequestsCount = signal(0);
  pendingRequestsCount = this.#pendingRequestsCount.asReadonly();

  increment(): void {
    this.#pendingRequestsCount.update((count) => count + 1);
  }

  decrement(): void {
    this.#pendingRequestsCount.update((count) => Math.max(0, count - 1));
  }
}
